module.exports = __webpack_public_path__ + "static/media/Group 1582@3x.736de2b7.png";